import type { ItemFieldRow } from './item-field-reader';
import { createEquippedIntegerCompiler } from './equipped-integer-contribution';
import type { EquippedIntegerDependencies } from './equipped-integer-contribution';
import { phpJsonString } from './php-json-values';

/** Native inventory essence adapter over the complete equipped-source walk.
 * The winning fixed value remains a lock; suppressed gear retains provenance.
 */
export function createInventoryEssenceSourceCollector(deps: EquippedIntegerDependencies) {
    const equipped = createEquippedIntegerCompiler(deps);
    return (row: ItemFieldRow, name: string): ItemFieldRow => {
        if (row === null || typeof row !== 'object') throw new TypeError('Inventory essence requires a PHP array');
        if (name == null || typeof name === 'object') throw new TypeError('Inventory essence requires a scalar string');
        const result = equipped.contribution(row, 'inventory_' + phpJsonString(name));
        return {lines: result.sources, rolled_total: result.total, rolled_total_brace: null, locked: result.locked};
    };
}
